import CheckSolidSVG from "@design-system/ui-icons/vanilla/CheckSolid"
import { createIcon } from "../createIcon"

export const CheckSolidIcon = createIcon(CheckSolidSVG)
